
import i18n from "../../../i18n";

const Title = i18n.t('manageAutomation.Title');
const Application = i18n.t('manageAutomation.Application');
const Date = i18n.t('manageAutomation.Date');
const Client = i18n.t('manageAutomation.Client');
const Details = i18n.t('manageAutomation.Details');

export const InsightsHeaders = [
    {
        key: 'error_title',
        header: Title,
        optional: false
    },
    {
        key: 'name',
        header: Application,
        optional: false
    },
    {
        key: 'client',
        header: Client,
        optional: false
    },
    {
        key: 'date',
        header: Date,
        optional: false
    },
    {
        key: 'details',
        header: Details,
        optional: true
    },
    {
        key: 'documentId',
        header: 'documentId',
        optional: true
    }
];

export const InsightsCarouselData = [{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "1",
    "_score": 1.0,
    "_source": {
        "acknowledged": ['user'],
        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps Commander",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    }
},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "2",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 2",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    }
},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "3",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],
        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 3",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "4",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 4",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "5",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 5",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "6",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 6",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "7",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 7",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "8",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 8",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "9",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 9",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "10",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 10",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

}, {
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "11",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 11",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "12",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 12",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 13",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 14",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 15",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 16",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 17",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 18",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 19",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

},
{
    "_index": "buildinsights",
    "_type": "_doc",
    "_id": "SX5jj4EB9X5q5fmfRJxB",
    "_score": 1.0,
    "_source": {
        "acknowledged": [''],

        "@timestamp": "2022-06-23T05:12:22.930Z",
        "host": "172.30.83.225",
        "topicname": "buildinsights",
        "appHostMachineName": "DSOUpdates",
        "sonar_message": {
            "Application_Name": "DevOps 20",
            "Error_message": "Some conditions are ignored",
            "Error_pushed_by": "DSO_Automation",
            "Error_date": "2020-12-14T11:40:36+0000",
            "Tenant_name": "IBM",
            "portfolio": "AppOps",
            "Application_instance_id": "62a314881ad94c392d847130",
            "Error_pushed_on": "2022-06-23T10:42:00",
            "Engagement": {
                "id": "10615",
                "name": "DevOps Commander"
            },
            "Tenant_id": "62a313b11ad94c392d846f3c",
            "Error_description": [
                "Condition new_coverage is ignored, which has an error threshold lesser than 80",
                "Condition new_duplicated_lines_density is ignored, which has an error threshold Greater than 3"
            ]
        }
    },

}
]